module.exports = __webpack_public_path__ + "static/team-thomas-uta-avatar-170px-OberionIO-c8837b5a7907e8d8fd2fcc28b42f781d.jpg";